import PropTypes from 'prop-types';
import VerificationInput from 'react-verification-input';

import styles from './CodeInput.module.scss';

export const CodeInput = ({
  className = '',
  autoFocus = true,
  onComplete = () => {},
  id,
  'aria-label': ariaLabel,
  length = 6,
}) => (
  <VerificationInput
    type="number"
    validChars="0-9"
    length={length}
    classNames={{
      container: [className],
      character: [styles.character],
      characterInactive: [styles.characterInactive],
    }}
    inputProps={{
      autoComplete: 'one-time-code',
      id,
      'aria-label': ariaLabel,
    }}
    onComplete={onComplete}
    autoFocus={autoFocus}
  />
);

CodeInput.propTypes = {
  className: PropTypes.string,
  autoFocus: PropTypes.bool,
  onComplete: PropTypes.func,
  id: PropTypes.string,
  'aria-label': PropTypes.string,
  length: PropTypes.number,
};
